import { render, staticRenderFns } from "./CampaignForm.vue?vue&type=template&id=630f61c4"
import script from "./CampaignForm.vue?vue&type=script&lang=js"
export * from "./CampaignForm.vue?vue&type=script&lang=js"
import style0 from "./CampaignForm.vue?vue&type=style&index=0&id=630f61c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports